export default "__VITE_ASSET__d791728e__"